/**
 * Copyright (c) 2022 Cedalo GmbH
 */

import { runQuery, useSubscription } from '@cedalo/webui/src/ui/app/GraphQLWSClient';
import { Path } from '@cedalo/webui/src/helper/Path';

import ACCOUNT_FORM_ACTION_MUTATION from '../accounts/account-form-action.gql';
import ACCOUNT_UPDATES_SUBSCRIPTION from '../accounts/account-updates.gql';
import ACCOUNT_QUERY from '../accounts/account.gql';
import DELETE_ACCOUNT_MUTATION from '../accounts/delete-account.gql';
import UPDATE_NAME_MUTATION from '../accounts/update-account-name.gql';
import ACCOUNTS_QUERY from '../accounts/accounts.gql';
import ACCOUNT_CHANGES_SUBSCRIPTION from '../accounts/account-changes.gql';
import CREATE_ACCOUNT_MUTATION from '../accounts/create-account.gql';
import ACCOUNT_MODULES_QUERY from '../accounts/account-modules.gql';

export const useAccountsSubscription = () => useSubscription(ACCOUNT_CHANGES_SUBSCRIPTION);
// export const useAccountUpdateSubscription = ({ accountId }) => useState([null, null]);
export const useAccountUpdateSubscription = (accountId) => useSubscription(ACCOUNT_UPDATES_SUBSCRIPTION, { accountId });

export const getAccounts = async () => {
	const result = await runQuery(ACCOUNTS_QUERY);
	return result.accounts;
};
// or throw?
export const getAccount = async (accountId) => {
	let result;
	try {
		// const { data = {}, errors } = await runQuery(ACCOUNT_QUERY, { accountId });
		// result = { account: data.account, errors };
		result = await runQuery(ACCOUNT_QUERY, { accountId });
	} catch (e) {
		result = { errors: [e.reason ? e.reason : e] };
	}
	return result;
};

export const runFormAction = async (formType, accountId, actionType, actionData /* = { id, value } */) => {
	const result = await runQuery(ACCOUNT_FORM_ACTION_MUTATION, {
		input: { form: formType, accountId, actionType, actionData }
	});
	return result;
};

export const deleteAccount = async (accountId) => {
	let result;
	try {
		const deleted = await runQuery(DELETE_ACCOUNT_MUTATION, { accountId });
		result = deleted.deleteAccount;
	} catch (e) {
		result = { success: false, message: e.message };
	}
	return result;
};

export const setAccountName = async (accountId, name) => {
	let result;
	try {
		const updated = await runQuery(UPDATE_NAME_MUTATION, { accountId, name });
		result = updated.updateAccountName;
	} catch (e) {
		result = { success: false, message: e.message };
	}
	return result;
};

export const createAccount = async (type) => {
	let result;
	try {
		const created = await runQuery(CREATE_ACCOUNT_MUTATION, { type });
		result = created.createAccount;
	} catch (error) {
		result = { success: false, message: error.message };
	}
	return result;
};

export const getAccountModules = async () => {
	let result;
	try {
		const { accountModules } = await runQuery(ACCOUNT_MODULES_QUERY);
		result = accountModules;
	} catch (error) {
		result = { success: false, message: error.message };
	}
	return result;
};

export const getIntlKey = (key) => {
	switch (key) {
		case 'TabTitle.Accounts':
			return 'TabTitle.Accounts';
		case 'Tooltip.Create':
			return 'Tooltip.CreateAccount';
		case 'Tooltip.CreateMessage':
			return 'Tooltip.CreateAccountMessage';
		case 'Table.Title':
			return 'Extensions.Accounts.Table.Title';
		case 'Table.SubTitle':
			return 'Extensions.Accounts.Table.SubTitle';
		case 'Table.Header.Type':
			return 'Extensions.Accounts.Table.Header.Type';
		case 'Settings.Title':
			return 'Extensions.Account.Settings';
		case 'Settings.NotSelected':
			return 'Extensions.Account.NotSelected';
		default:
			return key;
	}
};

export const getHelpContextSettings = () => {
	return 'overview/accounts#accounts';
}

export const getHelpContext = () => {
	return 'overview/accounts#accounts';
}

export const pathForId = (id) => Path.account(id);
